import { loadScript } from '../../common'
import { getShellLogger } from '../../common/logger'
import type { ExtensionConfig } from '../extension-config'
import type { ShellExtension } from '../shell-extension'
import { isShellExtension } from './type-checking'

/**
 * Loads an extension script
 * @param config extension configuration object
 * @returns instance of loaded extension or null if it fails or if it's invalid
 */
export const loadExtensionScript = async (config: ExtensionConfig): Promise<ShellExtension | null> => {
  try {
    const script = await loadScript<any>(config.url.href, { resolveWithGlobal: config.id, esModule: config.esModule })
    const extension = script.default || script
    if (isShellExtension(extension)) {
      return extension
    }
    getShellLogger().error(config.id, 'extension is not compliant with ShellExtension interface')
    return null
  } catch (e) {
    getShellLogger().error(config.id, 'extension failed to load', e)
    return null
  }
}
